export default __webpack_public_path__ + "static/media/SL_Chemistry.1cca7841.svg";